$(document).ready(function(){

	const accessibilityCarousel = function(slider, ariaControls){
		slider.on('init', function(event, slick){
		  slick.$slideTrack.attr({
		  	'id': ariaControls,
		  	'aria-live': 'off',
		  });
		  slick.$prevArrow.attr({
		  	'aria-controls': ariaControls,
		  });
		  slick.$nextArrow.attr({
		  	'aria-controls': ariaControls,
		  });
		  slick.$slides.each(function(){
		  	$(this).attr({
		  		'role': 'group',
		  		'aria-roledescription': 'slide',
		  		'aria-label': `Slide ${parseInt($(this).attr('data-slick-index'))+1} of ${slick.$slides.length}`,
		  	});
		  });
		});	
	};

	const sliderDefault = $('.slider__default');
	sliderDefault.each(function(index,value){
		var slider = $(this);
		accessibilityCarousel(sliderDefault, `sliderDefaultId-${index}`);
		slider.slick({
			arrows: true,
			dots: true,
			infinite: false,
			prevArrow: slider.parent().find('.btn--prev'),
			nextArrow: slider.parent().find('.btn--next'),
			appendDots: slider.parent().find('.slider__dots'),
		});
	});
});